import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: { token: null, maxSessionUntil: null },
  reducers: {
    setCredentials: (state, action) => {
      state.token = action.payload.token;
      state.maxSessionUntil = action.payload.maxSessionUntil ?? null;
    },
    clearCredentials: (state) => {
      state.token = null;
      state.maxSessionUntil = null;
    },
  },
});

export const { setCredentials, clearCredentials } = authSlice.actions;
export const selectCurrentToken = (state) => state.auth.token;
export const selectMaxSessionUntil = (state) => state.auth.maxSessionUntil;
export default authSlice.reducer;
